import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventMonthService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    onMonthChange(month) {
        this.invokeFirstComponentFunction.emit(month);
    }
}
EventMonthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventMonthService_Factory() { return new EventMonthService(); }, token: EventMonthService, providedIn: "root" });
